import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import Technologies from './Technologies';


const links =[
    {
        id: "about",
        text: "ABOUT ME",
    },  
    {
        id: "information",
        text: "INFORMATION",
    },
    {
        id: "work",
        text: "WORK",
    },
    {
        id: "contact",
        text: "CONTACT",
    }
]
const Skills = ({title,dark, id}) => {
    const classes = useStyles();
    return (
        <div className ={`${classes.section} ${dark && classes.sectiondark}`}>
        <div className={classes.sectioncontent} id={ id}>
                <Typography variant= "h3" className={classes.titlesection}>{title}</Typography>
                <Technologies/>
            </div>
    </div>
    )
}


const useStyles = makeStyles((theme) => ({
    section: {
        minHeight: "95vh"
    },
    titlesection:{
        fontFamily: "'Playfair Display', serif;",
        paddingLeft: "5rem",
        [theme.breakpoints.down('sm')]:{
            padding: "0px 20px",
            fontSize:"2rem"
        }
    },
    sectiondark: {
        background:  "#000",
        color: "#fff",
    },
    sectioncontent:{
        maxWidth: "90vw",
        margin: "0 auto",
        padding: theme.spacing(5),
        [theme.breakpoints.down('sm')]:{
            padding: theme.spacing(2),
           
        }
    },
}))
export default Skills
